export enum WishListType {
    OrganizationRead = 'ORGANIZATION_READ',
    OrganizationEdit = 'ORGANIZATION_EDIT',
}
